import { getAudioQualityPresets } from '@/services/Constants'
import { Button } from '@/UIComponents2/Button'
import { SidebarTooltip as Tooltip } from '@/pages/SessionPage/internal/sidebar/SidebarTooltip'
import { AudioInputStreamInfo } from '@/UserContext'
import { cn } from '@/utlis/cn'
import { useTranslation } from 'react-i18next'

type HQIndicatorProps = {
    mediaStreamInfo: AudioInputStreamInfo
    onClick?: () => void
}
export function HQIndicator(props: HQIndicatorProps) {
    const { t } = useTranslation()

    const mediaStreamQualityCode = (() => {
        if (props.mediaStreamInfo.isAudioEngine) {
            if (props.mediaStreamInfo.isCompressed) {
                if (props.mediaStreamInfo.compressionBitrate <= 96_000) {
                    return 'pro_essential'
                } else if (props.mediaStreamInfo.compressionBitrate <= 192_000) {
                    return 'pro_enhanced'
                } else {
                    return 'pro_hd'
                }
            } else {
                if (props.mediaStreamInfo.bitDepth <= 16) {
                    return 'pro_cd'
                } else if (props.mediaStreamInfo.bitDepth <= 24) {
                    return 'pro_studio'
                } else {
                    return 'pro_highest'
                }
            }
        } else {
            if (props.mediaStreamInfo.isHighQuality) {
                return 'enhanced'
            } else {
                return 'voice'
            }
        }
    })()

    const makeHqBadgeText = () => {
        if (mediaStreamQualityCode === 'voice') {
            return t('Streaming voice call quality audio.')
        }

        const preset = getAudioQualityPresets().find((a) => a.code === mediaStreamQualityCode)
        if (preset) {
            return t('Streaming high quality audio.') + ' ' + preset.title
        }
        return t('Streaming high quality audio.')
    }

    const isHq = props.mediaStreamInfo.isHighQuality || props.mediaStreamInfo.isAudioEngine

    return (
        <Tooltip text={makeHqBadgeText()} noNativeWrapper>
            <Button
                onClick={props.onClick}
                className={cn(
                    'w-[26px] min-w-[26px] h-[18px] flex rounded-[12px] text-black text-[10px] font-bold items-center justify-center',
                    isHq
                        ? 'bg-[#E7CA2D] text-black border-[2px] border-[#E7CA2D]'
                        : 'bg-[rgba(255,255,255,0.1)] text-[rgba(255,255,255,0.7)] border-[2px] border-white/5'
                )}
            >
                {'HQ'}
            </Button>
        </Tooltip>
    )
}
